(function () {

    Directives.CompanySubscriptionPricingCardsDirective = function CompanySubscriptionPricingCardsDirective() {

        // @ngInject
        function companySubscriptionPricingCardsCtor($scope, $injector, Enums, UsersManager, AbTestService, CompaniesManager, AnalyticsService, _, moment, PricingPlansService,
                                                     OnboardingService, FacebookPixelTrackingService,AppcuesService, AccountsManager, FullStoryService) {
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'CompanySubscriptionPricingCardsDirective';

            this.Enums = Enums;
            this.AbTestService = AbTestService;
            this.CompaniesManager = CompaniesManager;
            this.AnalyticsService = AnalyticsService;
            this.OnboardingService = OnboardingService;
            this.AppcuesService = AppcuesService;
            this._ = _;
            this.moment = moment;
            this.FacebookPixelTrackingService = FacebookPixelTrackingService;
            this.AccountsManager = AccountsManager;
            this.FullStoryService = FullStoryService;

            this.user = UsersManager.getCurrUser();
            this.company = this.user.company;

            const pricingPlanVariant = this.Enums.pricingPlanTypes.monthly;
            this.selectedPricingPlan = this.selectedPricingPlan || this._.find(this.pricingPlans, {plan_type: pricingPlanVariant || this.Enums.pricingPlanTypes.annual});

            PricingPlansService.on(Enums.PubSubTriggers.gotPricingPlans, function(data) {
                this._gotPricingPlans(data.pricingPlans);
            }.bind(this));

            $scope.$on('$destroy', function() {
                PricingPlansService.off(Enums.PubSubTriggers.gotPricingPlans);
            }.bind(this));
        }

        var CompanySubscriptionPricingCardsController = Class(Controllers.BaseController, {

            constructor: companySubscriptionPricingCardsCtor,

            toggleSelectedPricingPlan: function toggleSelectedPricingPlan() {
                var formWasOpen = this.selectedPricingPlan.isSelected; // `isSelected` is what opens the onboarding_payment_form
                if (this.selectedPricingPlan.plan_type === this.Enums.pricingPlanTypes.annual) {
                    this.selectedPricingPlan = this._.find(this.pricingPlans, {plan_type: this.Enums.pricingPlanTypes.monthly});
                    this.selectedPricingPlan.isSelected = formWasOpen; 
                } else {
                    this.selectedPricingPlan = this._.find(this.pricingPlans, {plan_type: this.Enums.pricingPlanTypes.annual});
                    this.selectedPricingPlan.isSelected = formWasOpen;
                }
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.pricing_plan_toggle, {source: this.selectedPricingPlan.plan_type});

            },

            submitPricingPlan: function submitPricingPlan(stripeToken, pricingPlanId) {
                var pricingPlanSubmitted = this._.find(this.pricingPlans, {_id: pricingPlanId});
                var analyticsEvent = 'submit payment plan';
                var analyticsData = {
                    plan_type: pricingPlanSubmitted.plan_type,
                    tier: pricingPlanSubmitted.tier,
                    promo: this.promoCode
                };

                this.AnalyticsService.trackClick(this, analyticsEvent, analyticsData);
                this.FullStoryService.trackEvent("Subscription",Object.assign({"attribution":this.user.attribution.user_source_secondary}, analyticsData));

                this.cardError = '';
                this.savingPricingPlan = true;

                var cardToAdd = stripeToken.card;
                cardToAdd.token_id = stripeToken.id;

                // return the promise so we can handle the errors in the same catch block
                var promoCode = pricingPlanSubmitted.promo_code ? pricingPlanSubmitted.promo_code._id : null;
                this.AccountsManager.createPricingPlan(this.company.account_id, pricingPlanId, promoCode, cardToAdd)
                    .then(function success(res) {
                        this.AnalyticsService.trackSuccess(this, analyticsEvent, analyticsData);

                        // adding MTA data
                        var source = "modal";
                        var mta_mixpanel_params = {};
                        mta_mixpanel_params.user_id = this.user._id;
                        mta_mixpanel_params.company_id = this.user.company._id;

                        this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.mta_subscribe, mta_mixpanel_params);
                        this.AnalyticsService.trackGA(this, "subscribe", undefined, "product attribution", this.user.attribution.user_source_secondary, true);
                        this.AppcuesService.trackEvent("subscribe", this.user);
                        // fix number we got from Dan (marketing) which stands for the user LTV
                        this.FacebookPixelTrackingService.track('Purchase',{'currency': 'USD', 'value': 1300.00, 'predicted_member_segment_measurement': this.user.account.predicted_member_segment_v5});

                        this._clearCurrentSelectedPlan();
                        this.AbTestService.onCompanySubscribed();
                        this.OnboardingService.onCompanySubscribed();
                        if (this.onPaymentSuccess) {
                            this.onPaymentSuccess({plan: res.data.pricing_plan});
                        }
                    }.bind(this))
                    .catch(function failure(res) {
                        var errorMessage =  'ERRORS.SERVER_API._UNKNOWN_'; //a default error message
                        if (res && res.error && res.error.message) {
                            errorMessage = res.error.message;
                        } else if (res && res.data && res.data.error_message) {
                            errorMessage = res.data.error_message;
                        }

                        this.cardError = errorMessage;

                        analyticsData.error = res ? res : "no error data";
                        this.AnalyticsService.trackError(this, analyticsEvent, analyticsData);
                    }.bind(this))
                    .finally(function finallyCallback() {
                        this.savingPricingPlan = false;
                    }.bind(this));
            },

            onPricingPlanSelected: function onPricingPlanSelected(pricingPlan) {
                if (!pricingPlan) {
                    return;
                }
                this._clearCurrentSelectedPlan();
                pricingPlan.isSelected = true;
                pricingPlan.isHighlighted = true;
            },

            formatDatetime: function formatDatetime(rawDatetime) {
                return this.moment(rawDatetime).format('MMM DD, YYYY');
            },

            convertAnnualToMonthlyPrice: function convertAnnualToMonthlyPrice(amount) {
                return Math.ceil(amount / 12);
            },

            _gotPricingPlans: function _gotPricingPlans(pricingPlans) {
                var monthlyPlan = this._.findWhere(pricingPlans, {plan_type: this.Enums.pricingPlanTypes.monthly});
                var annualPlan = this._.findWhere(pricingPlans, {plan_type: this.Enums.pricingPlanTypes.annual});

                var monthlyPrice, annualPrice;

                if ( monthlyPlan && monthlyPlan.is_discounted && annualPlan && annualPlan.is_discounted) {
                    monthlyPrice = monthlyPlan.original_amount;
                    annualPrice = annualPlan.original_amount;
                } else {
                    monthlyPrice = monthlyPlan.amount;
                    annualPrice = annualPlan.amount;
                }

                this.annualPriceWithoutDiscount = monthlyPrice * 12;
                this.annualSavingAmount = this.annualPriceWithoutDiscount - annualPrice;

                if (this.defaultPricingPlan) {
                    var preselectedPricingPlan = this._.find(pricingPlans, function (pricingPlan) {
                        return pricingPlan.plan_type === this.defaultPricingPlan;
                    }.bind(this));
                    this.onPricingPlanSelected(preselectedPricingPlan);
                }
            },

            _clearCurrentSelectedPlan: function _clearCurrentSelectedPlan() {
                this.pricingPlans.forEach(function pricingPlanIter(currPricingPlan) {
                    currPricingPlan.isSelected = false;
                    currPricingPlan.isHighlighted = false;
                }.bind(this));
            },

            isDiscounted: function isDiscounted() {
                return this.discountAmount() > 0;
            },

            discountAmount: function discountAmount() {
                if (this.selectedPricingPlan) {
                    var discount = 0;

                    if (this.selectedPricingPlan.is_discounted) {
                        discount = this.selectedPricingPlan.original_amount - this.selectedPricingPlan.amount;
                    }

                    this.referralDiscountPercent();

                    if (this.selectedPricingPlan.plan_type === this.Enums.pricingPlanTypes.annual) {
                        discount += this.annualSavingAmount;
                    }

                    return discount > 0 ? discount : 0;
                } else {
                    return 0;
                }
            },

            referralDiscountPercent: function referralDiscountPercent() {
                if (this.selectedPricingPlan && this.hasReferral()) {
                    var original_amount = this.selectedPricingPlan.original_amount || 0;
                    var amount_to_pay = this.selectedPricingPlan.amount || 0;

                    var discount = 0;

                    if (original_amount > 0) {
                        discount = (original_amount - amount_to_pay) / original_amount;
                    }

                    return parseInt(discount * 100, 10);
                } else {
                    return 0;
                }
            },

            hasReferral: function hasReferral() {
                return Boolean(this.selectedPricingPlan && this.selectedPricingPlan.is_discounted
                    && this.selectedPricingPlan._referrer_name);
            },

            isAnnualPricing: function isAnnualPricing() {
                return this.selectedPricingPlan && this.selectedPricingPlan.plan_type === this.Enums.pricingPlanTypes.annual;
            },

            discountTooltipText: function discountTooltipText() {
                var annualDiscountText = '$80 savings for Annual, plus ';

                return (this.isAnnualPricing() ? annualDiscountText : '') + this.referralDiscountPercent() + '% referral discount from ' + this.selectedPricingPlan._referrer_name;
            },
        });

        return {
            scope:{
                hideFeatures: '=?',
                onPaymentSuccess: '&?',
                hasPromoCode: '=?',
                pricingPlans: '=',
                defaultPricingPlan: '=?',
                promoCode: '=?',
                hasCanceledPlan: '=?',
                isPromocodePricingPlans: '=?',
                submitDiscountCode: '&?',
                lastError: '=?',
                showLastError: '=?',
                selectedPricingPlan: '=?'
            },
            templateUrl : 'angular/app/modules/core/features/settings/company/subscription/company_subscription_pricing_cards_directive_template.html',
            controller : CompanySubscriptionPricingCardsController,
            controllerAs : 'pricingCardsVm',
            bindToController : true
        };
    };
}());